export const COLUMBUS_COLORS: Array<{ id: number; i18nKey: string; hex: string; bgClass: string }> =
  [
    { id: 1, i18nKey: 'colors.blue', hex: '#3b82f6', bgClass: 'bg-[#3b82f6]' },
    { id: 2, i18nKey: 'colors.green', hex: '#22c55e', bgClass: 'bg-[#22c55e]' },
    { id: 3, i18nKey: 'colors.yellow', hex: '#eab308', bgClass: 'bg-[#eab308]' },
    { id: 4, i18nKey: 'colors.orange', hex: '#f97316', bgClass: 'bg-[#f97316]' },
    { id: 5, i18nKey: 'colors.red', hex: '#ef4444', bgClass: 'bg-[#ef4444]' },
    { id: 6, i18nKey: 'colors.purple', hex: '#a855f7', bgClass: 'bg-[#a855f7]' },
    { id: 7, i18nKey: 'colors.pink', hex: '#ec4899', bgClass: 'bg-[#ec4899]' },
  ];

export function getColorHex(colorCbId: number | null | undefined): string | undefined {
  if (colorCbId == null) return undefined;
  return COLUMBUS_COLORS.find((c) => c.id === colorCbId)?.hex;
}

export function getColorI18nKey(colorCbId: number | null | undefined): string | undefined {
  if (colorCbId == null) return undefined;
  return COLUMBUS_COLORS.find((c) => c.id === colorCbId)?.i18nKey;
}
